export default __webpack_public_path__ + "static/media/scene-07-we-build-our-own-ideas.7a5fb351.png";